var exports = {
  "J": "milestoneLink__WYKV70",
};

module.exports = exports;
